export default __webpack_public_path__ + "static/media/press_room_thumb5.264e1e6c.jpg";